<!-- @format -->

<ng-container *transloco="let t">
  <fudis-select
    [autocompleteFilter]="false"
    [size]="'lg'"
    [placeholder]="t('PLAN_EDIT.SELECTION_MODAL.SEARCH_PLACEHOLDER')"
    [label]="t('PLAN_EDIT.SELECTION_MODAL.ANY_COURSE_UNIT_RULE.SEARCH_COURSE_UNITS_LABEL')"
    [control]="courseUnitSelectControl"
    [variant]="'autocompleteType'"
    [helpText]="helpText ?? t('PLAN_EDIT.SELECTION_MODAL.SEARCH_HELP_TEXT')"
    [popoverText]="crossStudyFeaturesEnabled ? t('PLAN_EDIT.SELECTION_MODAL.SEARCH_POPOVER_TEXT') : null"
    [popoverTriggerLabel]="
      crossStudyFeaturesEnabled
        ? t('PLAN_EDIT.SELECTION_MODAL.SEARCH_POPOVER_TRIGGER_LABEL') +
          ', ' +
          t('PLAN_EDIT.SELECTION_MODAL.ANY_COURSE_UNIT_RULE.SEARCH_COURSE_UNITS_LABEL')
        : null
    "
    [popoverPosition]="'right'"
    (selectionUpdate)="updateSelected.emit($event?.value)"
    (filterTextUpdate)="searchTextUpdateSubject.next($event)">
    <ng-template fudisSelectOptions>
      @if (searchResults | async; as options) {
        @for (option of options.homeUniversityCourseUnits; track option) {
          <fudis-select-option [data]="option" />
        }
        @if (crossStudyFeaturesEnabled) {
          <fudis-select-group [label]="t('PLAN_EDIT.RIPA_SELECT_GROUP_LABEL')">
            @for (option of options.cooperationNetworkCourseUnits; track option) {
              <fudis-select-option [data]="option" />
            }
          </fudis-select-group>
        }
      }
    </ng-template>
  </fudis-select>
</ng-container>
